import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AdminPanelApplicationsFilterRequestDto } from "../../../api/apiServices/backOffice/controllers/adminPanel/adminPanel.requestsDto";
import { ApplicationLiteModel } from "../../../viewModels/Applications/ApplicationModel";

const initialState: {
  loading: boolean;
  loaded: boolean;
  error: boolean;
  applications?: Array<ApplicationLiteModel>;
  total: number;
} = {
  loading: true,
  loaded: false,
  error: false,
  applications: undefined,
  total: 0,
};

const adminPanelApplicationsSlice = createSlice({
  name: "adminPanelApplications",
  initialState,
  reducers: {
    loadApplications(state, _action: PayloadAction<AdminPanelApplicationsFilterRequestDto>) {
      state.loading = true;
      state.error = false;
    },
    loadApplicationsSuccess(state, action: PayloadAction<{ applications?: Array<ApplicationLiteModel>; total: number }>) {
      state.loading = false;
      state.loaded = true;
      state.error = false;
      state.applications = action.payload.applications;
      state.total = action.payload.total;
    },
    loadApplicationsFailure(state) {
      state.loading = false;
      state.error = true;
    },
  },
});

export default adminPanelApplicationsSlice;
